var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "my-modal",
      attrs: {
        id: "basic-modal",
        centered: "",
        "ok-variant": "warning",
        "cancel-variant": "dark",
        "hide-footer": _vm.hideFooter,
        size: _vm.size,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "modal-title",
            fn: function () {
              return [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
            },
            proxy: true,
          },
          {
            key: "modal-footer",
            fn: function () {
              return [
                _c("div", { staticClass: "w-100" }, [_vm._t("footer")], 2),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [_vm._v(" "), _c("main", [_vm._t("main")], 2)]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }